import gql from "graphql-tag";

export const RaiseNearMissMutation = gql`
  mutation RaiseNearMiss($input: RaiseNearMissInput!) {
    nearMisses {
      new(input: $input) {
        error {
          code
          message
        }
        nearMiss {
          id
          reference
        }
      }
    }
  }
`;
